export default {
  text: 'En utilisant ce site, vous acceptez nos',
  cookie_policy: 'Politique de cookies.',
  buttons: {
    accept: 'Accepter',
    reject: 'Refuser',
  },
};
